import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallbackMessage?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class VisualizationErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.warn('Visualization component error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full h-[700px] flex items-center justify-center bg-slate-blue rounded-lg">
          <div className="text-center p-8">
            <h3 className="text-xl font-bold text-white mb-2">
              Visualization Unavailable
            </h3>
            <p className="text-light-gray text-sm">
              {this.props.fallbackMessage || 'Unable to load this visualization. Please try refreshing the page.'}
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
